import React from "react";
import Header from "./components/header/Header";
import Sidebar from "./components/sidebar/Sidebar";
import { Outlet, useLocation } from "react-router-dom";
import AuthorizationWrap from '../app/authorizationWrap/AuthorizationWrap'
const Layout = (props) => {
  const location = useLocation();
  let routhPath = location.pathname.replace('/', '');
  let segments = location.pathname.split('/');
  if (segments.length > 1) {
    routhPath = segments[1];
  }
  const renderComponent = props.componentRoutes.filter((x) => x.id.toLowerCase() === routhPath.toLowerCase());
  return (
    <React.Fragment>
      <AuthorizationWrap authorizeRoleType={renderComponent ? renderComponent[0]?.allowrole : ''}>
        <div className="main-page-layout">

          <Sidebar componentRoutes={props.componentRoutes} />
          <div className={`middle-page-section`}>
            <Header />
            <div className="center-content-part">
              <div className="content-desc-section">
                {/* <BredcomTitle
                  pageTitle={renderComponent ? renderComponent.title : ""}
                /> */}
                <div className="center-container">
                  <Outlet />
                </div>
              </div>
            </div>
          </div>
        </div>
      </AuthorizationWrap>
    </React.Fragment>
  );
};

export default Layout;
